import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { Tooltip } from "@activecollab/components";
import PropTypes from "prop-types";
import { AssigneePicker } from "~/components/AssigneePicker";
import UserLink from "~/components/UserLink/UserLink";
import { getFilteredUsersFromProjectMembersForTaskUserSelector } from "~/store/selectors/selector.users.jsx";

export const UserPicker = ({ projectId, position, onChange, userId, userName, userEmail, hasPriviledges, ...rest }) => {
  const handleChange = useCallback(
    (userId) => {
      typeof onChange === "function" && onChange({ user_id: userId });
    },
    [onChange]
  );
  const options = useSelector((state) => {
    return getFilteredUsersFromProjectMembersForTaskUserSelector(state, projectId, true);
  });

  //disable edit if selected user is only one in list
  const isOnlyOne = options.some((option) => option.id === userId) && options.length === 1;

  if (!hasPriviledges || isOnlyOne)
    return (
      <Tooltip title={userName}>
        <span className="tw-flex tw-items-center">
          <UserLink
            id={userId}
            hideName
            name={userName}
            email={userEmail}
            className="tw-px-1"
            context="user picker"
          />
        </span>
      </Tooltip>
    );

  return (
    <AssigneePicker
      {...rest}
      options={options}
      position={position}
      onChange={handleChange}
      assigneeId={userId}
      noDefaultValue
      userName={userName}
      userEmail={userEmail}
      fakeAssigneeName={userName}
    />
  );
};

UserPicker.propTypes = {
  projectId: PropTypes.number.isRequired,
  position: PropTypes.string,
  userId: PropTypes.number,
  userName: PropTypes.string,
  userEmail: PropTypes.string,
  hasPriviledges: PropTypes.bool,
  onChange: PropTypes.func,
};
